const COMMUNITY_DEFINITIONS = [
  { value: "Afghan", slug: "afghan", label: "Afghan", flag: "af" },
  { value: "African", slug: "african", label: "African", flag: "un", icon: "🌍" },
  { value: "Algerian", slug: "algerian", label: "Algerian", flag: "dz" },
  { value: "American", slug: "american", label: "Americana", flag: "us" },
  { value: "Argentinian", slug: "argentinian", label: "Argentinian", flag: "ar" },
  { value: "Armenian", slug: "armenian", label: "Armenian", flag: "am" },
  { value: "Australian", slug: "australian", label: "Australian", flag: "au" },
  { value: "Bangladeshi", slug: "bangladeshi", label: "Bangladeshi", flag: "bd" },
  { value: "Brazilian", slug: "brazilian", label: "Brazilian", flag: "br" },
  { value: "British", slug: "british", label: "British", flag: "gb" },
  { value: "Cameroonian", slug: "cameroonian", label: "Cameroonian", flag: "cm" },
  { value: "Chinese", slug: "chinese", label: "Chinese", flag: "cn" },
  { value: "Colombian", slug: "colombian", label: "Colombian", flag: "co" },
  { value: "Cuban", slug: "cuban", label: "Cuban", flag: "cu" },
  { value: "Dominican", slug: "dominican", label: "Dominican", flag: "do" },
  { value: "Eritrean", slug: "eritrean", label: "Eritrean", flag: "er" },
  { value: "Ethiopian", slug: "ethiopian", label: "Ethiopian", flag: "et" },
  { value: "European", slug: "european", label: "European", flag: "eu" },
  { value: "Filipino", slug: "filipino", label: "Filipino", flag: "ph" },
  { value: "French", slug: "french", label: "French", flag: "fr" },
  { value: "German", slug: "german", label: "German", flag: "de" },
  { value: "Greek", slug: "greek", label: "Greek", flag: "gr" },
  { value: "Haitian", slug: "haitian", label: "Haitian", flag: "ht" },
  { value: "Hawaiian", slug: "hawaiian", label: "Hawaiian", flag: "us" },
  { value: "Indian", slug: "indian", label: "Indian", flag: "in" },
  { value: "Italian", slug: "italian", label: "Italian", flag: "it" },
  { value: "Jamaican", slug: "jamaican", label: "Jamaican", flag: "jm" },
  { value: "Japanese", slug: "japanese", label: "Japanese", flag: "jp" },
  { value: "Korean", slug: "korean", label: "Korean", flag: "kr" },
  { value: "Lebanese", slug: "lebanese", label: "Lebanese", flag: "lb" },
  { value: "Mexican", slug: "mexican", label: "Mexican", flag: "mx" },
  { value: "Middle Eastern", slug: "middle-eastern", label: "Middle Eastern", flag: "ae" },
  { value: "Nepali", slug: "nepali", label: "Nepali", flag: "np" },
  { value: "Nigerian", slug: "nigerian", label: "Nigerian", flag: "ng" },
  { value: "Pakistani", slug: "pakistani", label: "Pakistani", flag: "pk" },
  { value: "Palestinian", slug: "palestinian", label: "Palestinian", flag: "ps" },
  { value: "Persian", slug: "persian", label: "Persian/Iranian", flag: "ir" },
  { value: "Peruvian", slug: "peruvian", label: "Peruvian", flag: "pe" },
  { value: "Polish", slug: "polish", label: "Polish", flag: "pl" },
  { value: "Puerto Rican", slug: "puerto-rican", label: "Puerto Rican", flag: "pr" },
  { value: "Russian", slug: "russian", label: "Russian", flag: "ru" },
  { value: "Senegalese", slug: "senegalese", label: "Senegalese", flag: "sn" },
  { value: "Spanish", slug: "spanish", label: "Spanish", flag: "es" },
  { value: "Syrian", slug: "syrian", label: "Syrian", flag: "sy" },
  { value: "Thai", slug: "thai", label: "Thai", flag: "th" },
  { value: "Trinidadian", slug: "trinidadian", label: "Trinidadian", flag: "tt" },
  { value: "Turkish", slug: "turkish", label: "Turkish", flag: "tr" },
  { value: "Venezuelan", slug: "venezuelan", label: "Venezuelan", flag: "ve" },
  { value: "Vietnamese", slug: "vietnamese", label: "Vietnamese", flag: "vn" },
  { value: "Uzbekistan", slug: "uzbek", label: "Uzbek", flag: "uz" },
   
  {
  value: "Azerbaijani",
  slug: "azerbaijani",
  label: "Azerbaijani",
  flag: "az",
  showOnHub: true,
  comingSoon: true,
  url: "/communities/azerbaijani",
},
  {
  value: "Kazakh",
  slug: "kazakh",
  label: "Kazakh",
  flag: "kz",
  showOnHub: true,
  comingSoon: true,
  url: "/communities/kazakh",
},
{
  value: "Kyrgyz",
  slug: "kyrgyz",
  label: "Kyrgyz",
  flag: "kg",
  showOnHub: true,
  comingSoon: true,
  url: "/communities/kyrgyz",
},
{
  value: "Tajik",
  slug: "tajik",
  label: "Tajik",
  flag: "tj",
  showOnHub: true,
  comingSoon: true,
  url: "/communities/tajik",
},
{
  value: "Turkmen",
  slug: "turkmen",
  label: "Turkmen",
  flag: "tm",
  showOnHub: true,
  comingSoon: true,
  url: "/communities/turkmen",
},
{
  value: "Uzbek",
  slug: "uzbek",
  label: "Uzbek",
  flag: "uz",
  showOnHub: true,
  comingSoon: true,
  url: "/communities/uzbek",
},
];

const COMMUNITY_ALIASES = {
  "iranian": "Persian",
  "persian/iranian": "Persian",
  "nepalese": "Nepali",
  "puerto rico": "Puerto Rican",
  "middleeastern": "Middle Eastern",
  "middle-east": "Middle Eastern",
};

const safelyDecode = (value) => {
  try {
    return decodeURIComponent(String(value ?? ""));
  } catch {
    return String(value ?? "");
  }
};

export const normalizeCommunityValue = (value) =>
  safelyDecode(value)
    .trim()
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/-/g, " ")
    .replace(/\s+/g, " ");

export const slugifyCommunity = (value) =>
  normalizeCommunityValue(value)
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const titleCase = (value) =>
  normalizeCommunityValue(value)
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const COMMUNITY_META = COMMUNITY_DEFINITIONS.map((item) => ({
  ...item,
}));

export const COMMUNITY_SELECT_OPTIONS = [
  ...COMMUNITY_META.map((community) => ({
    value: community.value,
    label: community.label,
  })),
  { value: "Others", label: "Other community" },
];

export const resolveCommunityMeta = (input) => {
  const raw = safelyDecode(input).trim();
  const normalized = normalizeCommunityValue(raw);
  const aliasValue = COMMUNITY_ALIASES[normalized];

  if (aliasValue) {
    const aliasMatch = COMMUNITY_DEFINITIONS.find(
      (item) => item.value === aliasValue
    );

    if (aliasMatch) {
      return { ...aliasMatch };
    }
  }

  const slugMatch = COMMUNITY_DEFINITIONS.find(
    (item) => item.slug === raw.toLowerCase()
  );

  if (slugMatch) {
    return { ...slugMatch };
  }

  const valueMatch = COMMUNITY_DEFINITIONS.find(
    (item) => normalizeCommunityValue(item.value) === normalized
  );

  if (valueMatch) {
    return { ...valueMatch };
  }

  const labelMatch = COMMUNITY_DEFINITIONS.find(
    (item) => normalizeCommunityValue(item.label) === normalized
  );

  if (labelMatch) {
    return { ...labelMatch };
  }

  const fallbackValue = titleCase(raw) || "Community";

  return {
    value: fallbackValue,
    slug: slugifyCommunity(fallbackValue) || "community",
    label: fallbackValue,
    flag: "un",
    icon: "🌍",
  };
};

export const communityUrl = (input) => {
  const meta = resolveCommunityMeta(input);
  return `/communities/${meta.slug}`;
};

export const PINNED_COMMUNITY_CARDS = COMMUNITY_META
  .filter((community) => community.showOnHub === true)
  .map((community) => ({
    people: community.label,
    value: community.value,
    flag: community.flag,
    icon: community.icon,
    url:
      community.url ||
      communityUrl(community.value),
    count: 0,
    comingSoon:
      community.comingSoon !== false,
  }));
export const hubCommunityCards = COMMUNITY_META.map((community) => ({
  people: community.label,
  flag: community.flag,
  icon: community.icon,
  url: communityUrl(community.value),
  value: community.value,
}));

export default COMMUNITY_META;
